export { default } from './ActivityIndex';
